import * as React from 'react';
import styled from '@emotion/styled';
import { MDXProvider } from '@mdx-js/react';

import ThemeProvider from './theme/themeProvider';
import mdxComponents from './mdxComponents';
import Menu from './Menu';
import Topbar from './topbar';
import Sidebar from './sidebar';
import config from '../../config.js';

const TopBarWidth = styled('div')`
  width: 100%;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const Wrapper = styled('div')`
  flex-grow: 1;
  display: flex;
  justify-content: start;
  overflow: hidden;

  @media only screen and (max-width: 768px) {
    display: block;
    overflow: unset;
  }

  @media print {
    overflow: unset;
  }
`;

const Content = styled('main')`
  flex-grow: 1;
  padding: 8px var(--side-padding) 49px;
  overflow: auto;

  @media only screen and (min-width: 1921px) {
    padding: 8px 120px 49px;
  }

  @media (min-width: 1441px) and (max-width: 1920px) {
    padding: 8px calc(48px + 0.15 * (100vw - 1440px)) 49px;
  }

  @media (min-width: 769px) and (max-width: 1440px) {
    padding: 8px 48px 49px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0.16rem 0.2rem;
    overflow: unset;
  }

  @media print {
    padding: 16px 20px;
    overflow: unset;
  }
`;

const MaxWidth = styled('div')`
  max-width: var(--main-width);

  @media only screen and (max-width: 1440px) {
    max-width: calc(var(--main-width) - 120px);
  }
`;

const LeftSideBarWidth = styled('div')`
  box-sizing: content-box;
  flex-shrink: 0;
  padding: var(--side-padding);
  width: var(--side-width);
  background: rgba(236, 238, 240, 0.5);
  mix-blend-mode: multiply;
  overflow: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 769px) and (max-width: 1280px) {
    padding: var(--side-padding);
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }

  @media print {
    display: none;
  }
`;

const Layout = ({ children, location }) => (
  <ThemeProvider location={location}>
    <MDXProvider components={mdxComponents}>
      <Menu location={location} />
      <TopBarWidth>
        <Topbar location={location} />
      </TopBarWidth>
      <Wrapper>
        <LeftSideBarWidth>
          <Sidebar location={location} />
        </LeftSideBarWidth>
        {config.sidebar.title ? (
          <div
            className={'sidebarTitle sideBarShow'}
            dangerouslySetInnerHTML={{ __html: config.sidebar.title }}
          />
        ) : null}
        <Content id="content">
          <MaxWidth>{children}</MaxWidth>
        </Content>
      </Wrapper>
    </MDXProvider>
  </ThemeProvider>
);

export default Layout;
